module.exports = __webpack_public_path__ + "static/img/point.62907ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/point.png
// module id = uA6U
// module chunks = 36